import type { ValueSet, ValueSetComposeInclude } from '@medplum/fhirtypes';
import { SURVEY_CONFIGS } from '../questionnaire/surveys';

const URL = 'https://liza.health/fhir/ValueSet/surveys';

// Group the curated survey result codes by their coding system so a custom-system survey (e.g.
// `survey-scores | mood-scale`) is included alongside the LOINC-coded ones (PHQ-9, GAD-7). The
// picker `$expand`s this ValueSet; a concept only expands with its display when its CodeSystem is
// deployed, so every system referenced here must be a deployed CodeSystem.
const includeBySystem = new Map<string, ValueSetComposeInclude>();
for (const { resultSystem, resultCode, display } of SURVEY_CONFIGS) {
  const include = includeBySystem.get(resultSystem) ?? { system: resultSystem, concept: [] };
  include.concept!.push({ code: resultCode, display });
  includeBySystem.set(resultSystem, include);
}

export const lizaSurveysValueSet = {
  resourceType: 'ValueSet',
  name: 'liza-surveys',
  title: 'Liza Surveys',
  url: URL,
  // Mirror the canonical URL as a FHIR identifier so `deployResources` uses identifier-based
  // idempotency rather than name-based — stable if `name` is ever renamed.
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  version: '1',
  status: 'active',
  description: 'Curated set of survey total-score codes offered as care-plan results in Liza.',
  compose: {
    include: [...includeBySystem.values()],
  },
} satisfies ValueSet;
